import * as React from "react";
const SvgFiRrLemon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lemon_svg__a)">
      <path
        fill="#062147"
        d="M18 13a1 1 0 1 1-2.001 0 1 1 0 0 1 2 0m-3-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4.533-3.1C26.189 17.546 17.542 26.19 5.9 23.533c-.951-.382-1.9.51-2.9.467a3.017 3.017 0 0 1-2.622-4.455c.208-.465.244-.988.1-1.476-.9-4.563-.882-9.434 3.4-14.195C8.634-.4 13.505-.421 18.068.477a2.14 2.14 0 0 0 1.478-.1A3.017 3.017 0 0 1 24 3c.043 1-.848 1.94-.467 2.9m-1.655-2.42A1.006 1.006 0 0 0 21 2c-1.1.337-2.075.829-3.41.419C9.416.477 1.9 5.229 2.005 14.013c-.23 2.092 1.22 4.6.119 6.507a1 1 0 0 0 1.354 1.358c1.922-1.078 4.387.36 6.509.122 2.059-.027 5.93-.49 8.724-3.284s3.257-6.67 3.289-8.73c.23-2.131-1.2-4.586-.122-6.508z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lemon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLemon;
